import React from "react";

export default function SalesForceForms() {

  const styles = {
    input: {
      display: 'inline',
      borderTop: 'medium none',
      borderLeft: 'medium none',
      borderRight: 'medium none',
    },
    select: {
      borderTop:' medium none',
      borderLeft: 'medium none',
      borderRight: 'medium none',
      display: 'inline',
      height: '51px'
    },
    submitButton: {
      backgroundColor: 'rgb(0, 171, 235)',
      color: 'rgb(255, 255, 255)',
      border: 'medium none',
      borderRaduis: '0px',
      letterSpacing: '0.3em',
      fontSize: '12px'
    }
  };

  return (
  <div>
    {/* GENERAL INQUIRIES */}
    <div
      className="modal fade"
      id="general-inquiries-modal"
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: "700px" }}
      >
        <div className="modal-content">
          <div className="modal-header pb-0 border-none">
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body px-5">
            <h5 className="font-supersized font-weight-bold mb-4">General Inquiries</h5>
            <form action="https://webto.saleshtmlForce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">

              <input type="hidden" name="oid" value="00D8b00000134NM" />
              <input type="hidden" name="retURL" value="https://www.islandroutes.com/thank-you-contact-us" />


              <label htmlFor="first_name">First Name</label>
              <input id="first_name" maxLength="40" name="first_name" size="20" type="text"/>

              <label htmlFor="last_name">Last Name</label>
              <input id="last_name" maxLength="80" name="last_name" size="20" type="text" />

              <label htmlFor="email">Email</label>
              <input id="email" maxLength="80" name="email" size="20" type="text" />

              <label htmlFor="phone">Phone</label>
              <input id="phone" maxLength="40" name="phone" size="20" type="text" />

              <label>Customer Enquiry Type:</label>
              <select id="00N8b00000EZCDv" name="00N8b00000EZCDv"
                title="Customer Enquiry Type">
                <option value="">--None--</option><option value="General Inquiries">General Inquiries</option>
                <option value="Booking Questions">Booking Questions</option>
                <option value="Charter Requests">Charter Requests</option>
                <option value="DMC Requests">DMC Requests</option>
                <option value="Private Experiences">Private Experiences</option>
                <option value="Bespoke Experiences">Bespoke Experiences</option>
                <option value="Travel Advisor Requests">Travel Advisor Requests</option>
                <option value="Marketing/Media/Business Requests">Marketing/Media/Business Requests</option>
                <option value="Cancellation/Refund Requests">Cancellation/Refund Requests</option>
                <option value="Villas">Villas</option>
                <option value="Multi-Day experiences">Multi-Day experiences</option>
              </select>
              <br />

              <label>Client's message:</label>
              <textarea id="00N8b00000EZFcV" name="00N8b00000EZFcV" rows="4" type="text" wrap="soft"></textarea>
              <br />

              <input id="recordType" name="recordType" value="0128b0000008AOT" type="hidden" />
              <br />
              <input id="IR_Campaign__c" name="IR_Campaign__c" value="General Inquiries" type="hidden" />
              <br />
              <input type="submit" name="submit" className="btn btn-primary"/>

            </form>
          </div>
        </div>
      </div>
    </div>

    {/* GROUPS */}
    <div
      className="modal fade"
      id="groups-modal"
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-dialog-centered"
        role="document"
        style={{ maxWidth: "700px" }}
      >
        <div className="modal-content">
          <div className="modal-header pb-0 border-none">
            <button
             type="button"
             className="close"
             data-dismiss="modal"
             aria-label="Close"
            >
             <span aria-hidden="true">&times;</span>
            </button>
            
            <h5 className="font-supersized font-weight-bold mb-4">Groups</h5>
          </div>
          <div className="modal-body px-5">
            <form action="https://webto.saleshtmlForce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
              <input type="hidden" name="oid" value="00D8b00000134NM"/>
              <input type="hidden" name="retURL" value="https://www.islandroutes.com/thank-you-group-request"/>

              <div className="row my-3">
                <div className="col-6 pr-2">
                  <input 
                    className="w-100 p-3" 
                    placeholder="First Name" 
                    id="first_name" 
                    maxLength="40" 
                    name="first_name" 
                    size="20" 
                    type="text"
                    style={styles.input}
                  />
                </div>
                <div className="col-6 pr-2">
                  <input 
                    className="w-100 p-3" 
                    placeholder="Last Name" 
                    id="last_name" 
                    maxLength="80" 
                    name="last_name"
                    size="20" 
                    type="text"
                    style={styles.input}
                  />
                </div>
              </div>
              <div className="row my-3">
                <div className="col-6 pr-2">
                  <input
                    className="w-100 p-3" 
                    placeholder="Email" 
                    id="email" 
                    maxLength="80" 
                    name="email" 
                    size="20"
                    type="text"
                    style={styles.input}
                  />
                </div>
                <div className="col-6 pr-2">
                  <select 
                    className="w-100 p-3 bg-white" 
                    id="00N8b00000EZCDz" 
                    name="00N8b00000EZCDz"
                    title="Destination Interest"
                    style={styles.select}
                  >
                    <option value="Antigua">Destination Interest</option>
                    <option value="">--None--</option>
                    <option value="Antigua">Antigua</option>
                    <option value="Aruba">Aruba</option>
                    <option value="Bahamas">Bahamas</option>
                    <option value="Barbados">Barbados</option>
                    <option value="Curacao">Curacao</option>
                    <option value="Dominican Republic">Dominican Republic</option>
                    <option value="Grand Cayman">Grand Cayman</option>
                    <option value="Grenada">Grenada</option>
                    <option value="Jamaica">Jamaica</option>
                    <option value="Mexico">Mexico</option>
                    <option value="Saint Maarten">Saint Maarten</option>
                    <option value="St. Lucia">St. Lucia</option>
                    <option value="Turks & Caicos">Turks &amp; Caicos</option>
                  </select>
                </div>
              </div>
              <div className="row my-3">
                <div className="col-6 pr-2">
                  <textarea 
                    className="w-100 p-3" 
                    placeholder="Message"
                    id="00N8b00000EZFcV"
                    name="00N8b00000EZFcV"
                    rows="4" 
                    type="text"
                    wrap="soft"
                    style={styles.select}
                  ></textarea>                
                </div>
                <div className="col-6 pr-2">
                  <select className="w-100 p-3 bg-white"
                    id="00N8b00000EZFck"
                    name="00N8b00000EZFck"
                    title="Subscribed"
                    style={styles.select}
                  >
                    <option value="No">Subscribe to stay in touch?</option>
                    <option value="">--None--</option>
                    <option value="No">No</option>
                    <option value="Yes">Yes</option>
                  </select>
                </div>
              </div>
              <div>
                <input id="recordType" name="recordType" value="0128b0000008AOT" type="hidden"/>            
                <input id="IR_Campaign__c" name="IR_Campaign__c" value="Groups" type="hidden"/>            
              </div>
              <input 
                className="pt-3 pb-3 pl-6 pr-6 mt-6 col-12 text-uppercase" 
                type="submit" 
                name="submit" 
                style={styles.submitButton}
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  );
}



// WEBPACK FOOTER //
// ./resources/js/components/ContactUsModal/SalesForceForms.js